// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Sub-lists del modal cliente (referenti, documenti, scadenze) ======
// Estratte da clienti.js per ridurre la dimensione del modulo principale.
// Usano le variabili globalThis._referenti / _documenti / _scadenze popolate da clienti.js.

function renderReferentiList(items) {
  _referenti = (items || []).map((x) => ({ ...x }));
  const root = $('#referentiList');
  if (!_referenti.length) {
    root.innerHTML =
      '<div class="item-empty">Nessun referente. Aggiungi il primo contatto lato cliente.</div>';
    return;
  }
  root.innerHTML = _referenti
    .map(
      (r, i) => `
    <div class="item-card" data-idx="${i}">
      <div class="item-grid">
        <div class="field"><label>Nome e cognome</label><input data-key="nome" value="${escapeHtml(r.nome || '')}"></div>
        <div class="field"><label>Ruolo</label><input data-key="ruolo" value="${escapeHtml(r.ruolo || '')}" placeholder="Es. IT Manager"></div>
        <div class="field"><label>Email</label><input data-key="email" type="email" value="${escapeHtml(r.email || '')}"></div>
        <div class="field"><label>Telefono</label><input data-key="telefono" value="${escapeHtml(r.telefono || '')}"></div>
        <div class="field full"><label>Note</label><input data-key="note" value="${escapeHtml(r.note || '')}"></div>
      </div>
      <div class="item-actions"><button type="button" class="btn btn-sm btn-danger" data-remove>Rimuovi</button></div>
    </div>`
    )
    .join('');
  bindItemList(root, _referenti, () => renderReferentiList(_referenti), false, 'referente');
}

function renderDocumentiList(items) {
  _documenti = (items || []).map((x) => ({ ...x }));
  const root = $('#documentiList');
  if (!_documenti.length) {
    root.innerHTML =
      '<div class="item-empty">Nessun documento. Aggiungi link a procedure, runbook, SharePoint, oppure carica un file (PDF/immagini) come allegato.</div>';
    return;
  }
  root.innerHTML = _documenti
    .map((d, i) => {
      const isStorage = (d.url || '').startsWith('storage://');
      return `
    <div class="item-card" data-idx="${i}">
      <div class="item-grid">
        <div class="field"><label>Titolo</label><input data-key="titolo" value="${escapeHtml(d.titolo || '')}" placeholder="Es. Runbook backup"></div>
        <div class="field"><label>Tipo</label><input data-key="tipo" value="${escapeHtml(d.tipo || '')}" placeholder="Procedura, contratto, schema"></div>
        <div class="field full">
          <label>URL ${isStorage ? '<span class="muted" style="font-size:11px;">(allegato Storage)</span>' : ''}</label>
          <input data-key="url" type="text" value="${escapeHtml(d.url || '')}" placeholder="https://... oppure allega file qui sotto">
        </div>
        <div class="field full">
          <label>Allegato</label>
          <label class="btn btn-sm" style="cursor:pointer;display:inline-block;">
            <svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21V9"/><polyline points="7 14 12 9 17 14"/><path d="M5 3h14"/></svg>
            Carica file
            <input type="file" data-upload-idx="${i}" style="display:none;" accept="application/pdf,image/*,.docx,.xlsx,.txt">
          </label>
          ${
            isStorage
              ? `<button type="button" class="btn btn-sm" data-storage-preview="${escapeHtml(d.url)}" data-titolo="${escapeHtml(d.titolo || d.tipo || 'documento')}"><svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>Anteprima</button>
                <button type="button" class="btn btn-sm" data-storage-open="${escapeHtml(d.url)}"><svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>Apri allegato</button>`
              : ''
          }
        </div>
        <div class="field full"><label>Note</label><input data-key="note" value="${escapeHtml(d.note || '')}"></div>
      </div>
      <div class="item-actions">
        ${d.url && !isStorage ? `<a href="${escapeHtml(d.url)}" target="_blank" rel="noopener" class="btn btn-sm">Apri link ↗</a>` : ''}
        <button type="button" class="btn btn-sm btn-danger" data-remove>Rimuovi</button>
      </div>
    </div>`;
    })
    .join('');
  // Wire upload e open storage
  root.querySelectorAll('input[type="file"][data-upload-idx]').forEach((input) => {
    input.addEventListener('change', async (e) => {
      const idx = parseInt(input.dataset.uploadIdx, 10);
      const file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      await uploadDocumentoForRow(idx, file, () => renderDocumentiList(_documenti));
    });
  });
  root.querySelectorAll('[data-storage-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openStorageDocument(btn.dataset.storageOpen);
    });
  });
  root.querySelectorAll('[data-storage-preview]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof previewStorageDocument === 'function') {
        previewStorageDocument(btn.dataset.storagePreview, btn.dataset.titolo);
      } else {
        openStorageDocument(btn.dataset.storagePreview);
      }
    });
  });
  bindItemList(root, _documenti, () => renderDocumentiList(_documenti), false, 'documento');
}

function renderScadenzeListModal(items) {
  _scadenze = (items || []).map((x) => ({ ...x }));
  const root = $('#scadenzeListModal');
  if (!_scadenze.length) {
    root.innerHTML = '<div class="item-empty">Nessuna scadenza registrata.</div>';
    return;
  }
  root.innerHTML = _scadenze
    .map((s, i) => {
      const g = daysUntil(s.data);
      return `
    <div class="item-card" data-idx="${i}">
      <div class="item-grid">
        <div class="field"><label>Titolo</label><input data-key="titolo" value="${escapeHtml(s.titolo || '')}" placeholder="Es. Rinnovo certificato"></div>
        <div class="field"><label>Tipo</label><input data-key="tipo" list="scadTipoList" value="${escapeHtml(s.tipo || '')}" placeholder="Contratto, Certificato, Password">
          <datalist id="scadTipoList"><option value="Contratto"><option value="Certificato"><option value="Password admin"><option value="Audit"><option value="Formazione"><option value="Rinnovo licenza"></datalist>
        </div>
        <div class="field"><label>Data</label><input data-key="data" type="date" value="${escapeHtml(s.data || '')}"></div>
        <div class="field"><label>Stato</label>
          <select data-key="completata">
            <option value="false" ${!s.completata ? 'selected' : ''}>Aperta</option>
            <option value="true" ${s.completata ? 'selected' : ''}>Completata</option>
          </select>
        </div>
        <div class="field full"><label>Note</label><input data-key="note" value="${escapeHtml(s.note || '')}"></div>
      </div>
      <div class="item-actions">
        ${s.data && !s.completata ? `<span class="deadline-pill ${deadlinePillClass(g)}">${formatGiorni(g)}</span>` : ''}
        <button type="button" class="btn btn-sm btn-danger" data-remove>Rimuovi</button>
      </div>
    </div>`;
    })
    .join('');
  bindItemList(root, _scadenze, () => renderScadenzeListModal(_scadenze), true, 'scadenza');
}

function bindItemList(root, arr, rerender, withBoolean = false, itemLabel = 'voce') {
  root.querySelectorAll('.item-card').forEach((card) => {
    const idx = parseInt(card.dataset.idx, 10);
    card.querySelectorAll('[data-key]').forEach((input) => {
      const handler = () => {
        const k = input.dataset.key;
        let v = input.value;
        if (withBoolean && k === 'completata') v = v === 'true';
        arr[idx][k] = v;
      };
      input.addEventListener('input', handler);
      input.addEventListener('change', handler);
    });
    const rem = card.querySelector('[data-remove]');
    if (rem)
      rem.addEventListener('click', async () => {
        const item = arr[idx] || {};
        const hasContent = Object.entries(item).some(
          ([k, v]) => k !== 'id' && k !== 'completata' && typeof v === 'string' && v.trim()
        );
        if (hasContent) {
          const itemName = item.titolo || item.nome || '';
          const ok = await confirmAction({
            level: 'info',
            title: `Rimuovere ${itemLabel}`,
            message: itemName
              ? `Stai per rimuovere "${itemName}" dalla scheda cliente.`
              : `Stai per rimuovere questa ${itemLabel} dalla scheda cliente.`,
            details: [
              'La rimozione diventa definitiva solo quando salvi il cliente',
              'Annullando il salvataggio della scheda i dati restano intatti'
            ],
            confirmText: 'Rimuovi'
          });
          if (!ok) return;
        }
        arr.splice(idx, 1);
        rerender();
      });
  });
}

Object.assign(globalThis, {
  renderReferentiList,
  renderDocumentiList,
  renderScadenzeListModal,
  bindItemList
});
export {};
